// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SecurityProvider } from './contexts/SecurityContext';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import PodcastDetailsPage from './pages/PodcastDetailsPage';
import GlobalPlayerUI from './components/GlobalPlayerUI';
import AnalyticsPage from './pages/AnalyticsPage';


// This component will protect routes that require authentication
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }
  return children ? children : <Outlet />;
};

// Wrapper component to access auth context
function AppRoutes() {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading application...</div>;
  }

  return (
    <Router>
      <div className="App">
        <div style={{ paddingBottom: '80px' }}>
          <Routes>
            <Route
              path="/"
              element={!currentUser ? <LoginPage /> : <Navigate to="/home" replace />}
            />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/home" element={<HomePage />} />
              <Route path="/search-results/:query" element={<SearchResultsPage />} />
              <Route path="/podcast/:podcastId" element={<PodcastDetailsPage />} />
            </Route>

            <Route path="/analytics" element={<AnalyticsPage />} />

            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </div>

        <GlobalPlayerUI />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <SecurityProvider>
        <AppRoutes />
      </SecurityProvider>
    </AuthProvider>
  );
}

export default App;